module.exports = __webpack_public_path__ + "img/EMS_user_manual_timeline12.6f1e730b.png";